import Icon from 'veui/components/Icon'

Icon.register({
  'text-bold': {
    paths: [
      {
        d: 'M512 704H192a32 32 0 01-32-32V96a32 32 0 0132-32h288c88.22 0 160 71.78 160 160a159.55 159.55 0 01-47.52 113.69C658.26 368.18 704 434.85 704 512c0 105.87-86.13 192-192 192zm-288-64h288a128 128 0 000-256H320a32 32 0 010-64h160a96 96 0 000-192H224z'
      }
    ],
    width: '768',
    height: '768'
  }
})
